// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "paella" + "." + "f2de505117d77393c116" + ".js";
};